import { COLUMNS_REPORTE_EMBARQUE_SECTOR_3_LINEA_7_TO_PRINT, COLUMNS_REPORTE_EMBARQUE_SECTOR_3_LINEA_7 } from './constantesreporteEmbarqueSector3Linea7'
import { TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_7 } from '../../../../../../config/tables'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'
import { ReporteEmbarqueSector3Linea7Service } from '../../../../../../models/movimiento/ReporteEmbarquePorSector/tabla_reporte_embarque_sector_3_linea_7'

export function actualizarDatosParaMuiTable (cereal, cerealVariedad, etiqueta) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_7
    })
    const promiseReporteEmbarqueSector3Linea7 = ReporteEmbarqueSector3Linea7Service.getDataReporteEmbarqueSector3Linea7(cereal, cerealVariedad, etiqueta)
    const promiseReporteEmbarqueSector3Linea7Total = ReporteEmbarqueSector3Linea7Service.getDataReporteEmbarqueSector3Linea7Total(cereal, cerealVariedad, etiqueta)
    Promise.all([promiseReporteEmbarqueSector3Linea7, promiseReporteEmbarqueSector3Linea7Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = (dataArray[1] || [])[0] || {}
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Reporte Embarque Sector 3 Linea 7',
        dataCombinada,
        COLUMNS_REPORTE_EMBARQUE_SECTOR_3_LINEA_7_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_REPORTE_EMBARQUE_SECTOR_3_LINEA_7,
          data: dataCombinada,
          title: `Reporte Embarque Sector 3 Linea 7`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false }
        },
        id: TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_7
      })
    }
  }
}
